/**
 * A one-shot, scenario-scoped permission to move the user's viewport.
 *
 * Rows enter the Bryntum store from two very different sources through the same
 * code path: a create the local user just asked for, and a background sync
 * carrying someone else's changes. Scrolling on the second would yank the
 * viewport away from whatever the user is reading, so the reveal is gated on an
 * intent that only a local create arms.
 */

// A scope import refetches and re-transforms the whole scenario before the new
// rows reach the store, which on a large planning is several seconds.
export const REVEAL_INTENT_TTL_MS = 30000;

let intent = null;

export const armRevealIntent = ({ scenarioId } = {}) => {
  intent = {
    scenarioId: scenarioId == null ? null : String(scenarioId),
    armedAt: Date.now(),
    userMoved: false,
  };
};

/**
 * The user scrolled between asking for the create and the rows arriving — they
 * have moved on, so the reveal keeps its flash but gives up the scroll.
 */
export const markRevealIntentStale = () => {
  if (intent) intent.userMoved = true;
};

export const clearRevealIntent = () => {
  intent = null;
};

export const consumeRevealIntent = (scenarioId) => {
  if (!intent) return null;

  const expired = Date.now() - intent.armedAt > REVEAL_INTENT_TTL_MS;
  const otherScenario =
    intent.scenarioId != null &&
    scenarioId != null &&
    intent.scenarioId !== String(scenarioId);

  if (expired || otherScenario) {
    if (expired) intent = null;
    return null;
  }

  const { userMoved } = intent;
  intent = null;
  return { scroll: !userMoved };
};
